var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: _vm.buttonClassList,
      attrs: { href: _vm.url, target: _vm.target, disabled: _vm.disabled },
      on: { click: _vm.clickHandler }
    },
    [
      _c("span", {
        staticClass:
          "absolute -inset-1.5 opacity-0 group-focus:opacity-100 border-2 border-grey-900 border-solid rounded-lg transition-opacity duration-200 ease-in-out pointer-events-none"
      }),
      _vm._v(" "),
      _vm.iconId !== null && !_vm.iconReversed
        ? _c("Sprite", {
            class: _vm.defaultIconClassList,
            attrs: { id: _vm.iconId }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        class: [
          "u-body-md font-bold border-b-2 border-solid border-transparent group-hover:border-current transition-colors duration-200 ease-in-out",
          _vm.textColour,
          _vm.labelClassList
        ],
        domProps: { innerHTML: _vm._s(_vm.label) }
      }),
      _vm._v(" "),
      _vm.iconId !== null && _vm.iconReversed
        ? _c("Sprite", {
            class: _vm.defaultIconClassList,
            attrs: { id: _vm.iconId }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }